module.exports = __webpack_public_path__ + "static/media/DrumsScore2-KELsMUSIC.c15c3d80.jpg";